import { render, staticRenderFns } from "./EditUserHome.vue?vue&type=template&id=af84b484&scoped=true"
import script from "./EditUserHome.vue?vue&type=script&lang=js"
export * from "./EditUserHome.vue?vue&type=script&lang=js"
import style0 from "./EditUserHome.vue?vue&type=style&index=0&id=af84b484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af84b484",
  null
  
)

export default component.exports